// Upgrade.ts
import { GRADE, IMP_CODE, PaymentData } from "../components/common/Common";
import { RequestPayParams } from "../components/pricepolicy/IamPort";
import DataProvider from "../data_provider/DataProvider";

interface UpgradeCallbacks {
    onSuccess: () => void;
    onError: (error: string) => void;
}

/**
 * 모두의지도 PRO 서비스 결제를 위한 아임포트(IMP) 결제 요청 함수
 * @param PaymentData - 사용자 결제 관련 정보
 * @param UpgradeCallbacks - 결제 성공/실패 처리 콜백 핸들러
 * @returns 
 */
const Upgrade = async (
    { name, email, pg, upgradeType }: PaymentData,
    { onSuccess, onError }: UpgradeCallbacks
) => {
    if (!window.IMP) {
        onError("결제 라이브러리가 로드되지 않았습니다.");
        return;
    }

    if (!email || !name) {
        onError("로그인이 필요한 서비스입니다.");
        return;
    }

    const { IMP } = window;
    const timestamp = new Date().getTime();
    const merchant_uid = `MODOOMAP-${timestamp}`;
    const customer_uid = `${email}-${timestamp}`;

    IMP.init(`imp${IMP_CODE}`);

    const reqParam: RequestPayParams = {
        pg: pg ?? "danal_pay",
        pay_method: "card",
        merchant_uid,
        name: "모두의지도 프로버전",
        amount: GRADE[upgradeType ?? "pro"]?.price ?? 20000,
        customer_uid,
        buyer_email: email,
        buyer_name: name,
    };
    // IMP iframe 태그의 상단 여백을 줘서 삽입되는 IMP document 의 위치 간접적으로 조절
    const style = document.createElement('style');
    style.textContent = `
    .imp-frame {
        transform: translate(-50%, -50%) !important;
        height: 70% !important;
        width: 70% !important;
        top: 60% !important;
        left: 50% !important;
    }
    `;
    document.head.appendChild(style);

    IMP.request_pay(reqParam, async (res) => {
        const { success, error_msg } = res;
        if (success) {
            await DataProvider.UpgradeUser({
                merchantUID: merchant_uid,
                customerUID: customer_uid,
                impUID: res.imp_uid!,
            });
            onSuccess();
        } else {
            onError(error_msg || "결제 실패");
        }
    });
};

export default Upgrade;
